<template>
  <div class="live-virtual-training-card" @click="updateSelectedLVT(liveVirtualTraining)">
    <div
      :class="[
        'live-virtual-training-card__header',
        liveVirtualTraining.upNext && 'live-virtual-training-card__header--up-next',
      ]"
    >
      <div class="live-virtual-training-card__instructor">
        <img
          class="live-virtual-training-card__instructor-img"
          :src="liveVirtualTraining.icon"
          :alt="liveVirtualTraining.instructorName"
        />
        <LiveVirtualTraining class="live-virtual-training-card__instructor-promo" />
        <LiveVirtualTrainingMobile class="live-virtual-training-card__instructor-promo--mobile" />
        <div
          v-if="liveVirtualTraining.includedFeature && !userWithDiscount"
          class="live-virtual-training-card__header-included-feature"
        >
          <Pill class="live-virtual-training-card__header-included-feature-pill" info>
            {{ `${liveVirtualTraining.includedFeature}*` }}
          </Pill>
          <div class="live-virtual-training-card__header-included-feature-detail">
            {{ `*${liveVirtualTraining.includedFeatureDetail} (${liveVirtualTraining.startDate})` }}
          </div>
        </div>
      </div>
      <div class="live-virtual-training-card__check-box">
        <CheckBox :isSelected="isSelected" />
      </div>
    </div>
    <div class="live-virtual-training-card__title">
      {{ liveVirtualTraining.name }}
    </div>
    <div class="live-virtual-training-card__price">
      <div
        :class="[
          'live-virtual-training-card__price-wrapper',
          userWithDiscount &&
            displayCoupon &&
            'live-virtual-training-card__price-wrapper--discount',
        ]"
      >
        <span class="live-virtual-training-card__price-amount">
          {{ price }}
          <span class="live-virtual-training-card__price-amount--cents">{{ cents }}</span>
        </span>
        <div
          :class="[
            'live-virtual-training-card__price-coupon-wrapper',
            userWithDiscount && 'live-virtual-training-card__price-coupon-wrapper--row',
          ]"
        >
          <div v-if="displayCoupon">
            <div
              :class="[
                'live-virtual-training-card__price-coupon',
                userWithDiscount && 'live-virtual-training-card__price-coupon--row',
              ]"
            >
              {{ percentageDiscountText }}
              <span
                :class="[
                  'live-virtual-training-card__price-coupon--code',
                  userWithDiscount && 'live-virtual-training-card__price-coupon--code-margin',
                ]"
                >{{ computedCouponCode }}</span
              >
            </div>
          </div>
          <span v-if="displayCoupon" class="live-virtual-training-card__price-wrapper--description"
            >Discounted prices are shown</span
          >
        </div>
      </div>
      <div v-if="!userWithDiscount" :class="['live-virtual-training-card__price-discount']">
        <div class="live-virtual-training-card__price-discount-text">
          {{ `$${priceForActiveSubscribers} for Active Subscribers` }}
        </div>
        <div class="live-virtual-training-card__price-discount-plans">
          (Premium, Enterprise, or Professional Plans)
        </div>
      </div>
    </div>
    <div class="live-virtual-training-card__details">
      {{ liveVirtualTraining.description }}
    </div>
    <div v-if="liveVirtualTraining.descriptionAppend" class="live-virtual-training-card__details">
      {{ liveVirtualTraining.descriptionAppend }}
    </div>
    <div class="live-virtual-training-card__details-two">
      <div v-if="liveVirtualTraining.instructorName">
        Expert Led Training by {{ liveVirtualTraining.instructorName }}
      </div>
      <div v-if="liveVirtualTraining.startDate">
        {{
          `${liveVirtualTraining.startDate} - ${liveVirtualTraining.endDate}, ${liveVirtualTraining.year}, ${liveVirtualTraining.schedule}`
        }}
      </div>
    </div>
    <div
      v-if="!liveVirtualTraining.user_receives_discount && liveVirtualTraining.includedFeature"
      class="live-virtual-training-card__included-feature"
    >
      {{ `${liveVirtualTraining.includedFeature} - ${liveVirtualTraining.includedFeatureDetail}` }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CheckBox from '@/components/shared/CheckBox.vue'
import Pill from '@/components/shared/Pill.vue'
import LiveVirtualTraining from '@/assets/icons/live-virtual-training.svg'
import LiveVirtualTrainingMobile from '@/assets/icons/live-virtual-training-mobile.svg'
import { updateCart } from '@/helpers/mixins'

export default {
  name: 'PlanItemLiveVirtualTrainingCard',
  mixins: [updateCart],
  props: {
    liveVirtualTraining: {
      type: Object,
      required: true,
    },
    displayCoupon: {
      type: Boolean,
      default: false,
    },
    LVTCoupon: {
      type: Object,
    },
  },
  components: {
    CheckBox,
    LiveVirtualTraining: {
      ...LiveVirtualTraining,
      name: 'LiveVirtualTraining',
    },
    LiveVirtualTrainingMobile: {
      ...LiveVirtualTrainingMobile,
      name: 'LiveVirtualTrainingMobile',
    },
    Pill,
  },
  methods: {
    applyCouponToPrice(price) {
      let calculatedPrice = price
      if (this.displayCoupon && this.computedCouponCode !== '' && this.computedCouponPercentage) {
        calculatedPrice -= (calculatedPrice * this.computedCouponPercentage) / 100
      }
      return calculatedPrice
    },
  },
  computed: {
    ...mapState({
      usersCurrentSubscriptions: state => state.subscriptions.usersCurrentSubscriptions,
      businessUser: state => state.business.businessUser,
    }),
    isSelected() {
      return !!this.shoppingCart.find(
        item => item.merchant_id === this.liveVirtualTraining.merchant_id
      )
    },
    discountedPriceCents() {
      return this.liveVirtualTraining.discounted_price_cents / 100
    },
    computedCouponCode() {
      return this.LVTCoupon?.code
    },
    computedCouponPercentage() {
      return this.LVTCoupon?.percentage || 0
    },
    percentageDiscountText() {
      return `${this.computedCouponPercentage}% OFF WITH CODE:`
    },
    userWithDiscount() {
      return this.liveVirtualTraining.user_receives_discount
    },
    totalPrice() {
      const calculatedPrice = this.userWithDiscount
        ? this.discountedPriceCents
        : this.liveVirtualTraining.price_cents / 100
      return this.applyCouponToPrice(calculatedPrice)
    },
    priceForActiveSubscribers() {
      return this.applyCouponToPrice(this.discountedPriceCents)
    },
    price() {
      const priceWithouCents = String(this.totalPrice).split('.')[0]
      return `$${priceWithouCents}`
    },
    cents() {
      const priceCents = String(this.totalPrice).split('.')[1]
      return priceCents ? `.${priceCents}` : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.live-virtual-training-card {
  background: var(--mid-gray-gradient);
  border-radius: 10px;
  padding: 20px;
  position: relative;
  cursor: pointer;
  transition: all 1s ease-out;
  &:hover {
    background: var(--mid-gray-translucid-gradient);
  }
  &:active {
    transition: all 0.5s ease-out;
    background: var(--charcoal-gradient-two);
  }
  @include mobile {
    padding: 20px 40px;
  }
  @include tablet {
    max-width: 550px;
  }
  &--hide {
    display: none !important;
  }
  &__header {
    display: flex;
    justify-content: space-between;
    background: rgb(40, 70, 100);
    background: linear-gradient(
      90deg,
      rgba(40, 70, 100, 1) 0%,
      rgba(180, 70, 190, 1) 30%,
      rgba(40, 70, 100, 1) 90%
    );
    width: calc(100% + 40px);
    height: 90px;
    padding: 20px;
    border-radius: 10px 10px 0 0;
    position: relative;
    inset: -20px -20px 0;
    margin-bottom: 40px;
    @include mobile {
      width: calc(100% + 80px);
      height: 140px;
      inset: -20px -40px 0;
      padding: 40px;
    }
    &--up-next {
      background: rgb(35, 80, 120);
      background: linear-gradient(
        90deg,
        rgba(35, 80, 120, 1) 0%,
        rgba(30, 175, 115, 1) 30%,
        rgba(35, 80, 120, 1) 90%
      );
    }
    &-included-feature {
      position: absolute;
      top: 77px;
      right: 20px;
      display: flex;
      flex-flow: column;
      align-items: self-end;
      gap: 10px;
      @include mobile {
        top: 127px;
        right: 40px;
      }
      &-detail {
        color: var(--dusty-gray);
        font-size: rem(12px);
        font-style: normal;
        font-weight: 450;
        line-height: rem(14px);
      }
    }
  }
  &__instructor {
    &-img {
      border-radius: 50%;
      width: 110px;
      @include mobile {
        width: 145px;
      }
    }
    &-promo {
      position: relative;
      bottom: 70px;
      right: 30px;
      display: none;
      @include desktop {
        display: inline-flex;
      }
      &--mobile {
        position: relative;
        bottom: 50px;
        right: 20px;
        @include mobile {
          bottom: 70px;
          right: 30px;
        }
        @include desktop {
          display: none;
        }
      }
    }
  }
  &__title {
    font-weight: 700;
    font-size: rem(24px);
    line-height: 32px;
    display: flex;
    align-items: center;
  }
  &__price {
    font-weight: 700;
    font-size: rem(54px);
    line-height: rem(66px);
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    gap: 10px;
    margin: 0 0 35px 0;
    @include mobile {
      flex-flow: row;
      align-items: center;
    }
    &-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0;

      &--discount {
        width: 100%;
        align-items: flex-start;
        flex-direction: column;
        justify-content: center;
        @include mobile {
          align-items: center;
          flex-direction: row;
          justify-content: flex-start;
        }
      }
      &--description {
        color: var(--light-blue-gray);
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 450;
        line-height: 20px;
      }
    }
    &-amount {
      display: flex;
      align-items: flex-start;
      &--cents {
        font-size: 24px;
        line-height: 50px;
      }
    }
    &-coupon {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: var(--strong-light-green);
      font-size: 14px;
      font-weight: 450;
      line-height: 20px;
      text-align: center;
      &--row {
        flex-direction: row;
        width: 100%;
      }
      &--code {
        font-weight: 700;
        line-height: 20px;
        &-margin {
          margin-left: 4px;
        }
      }
      &-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0;
        &--row {
          margin-left: 10px;
          align-items: flex-start;
        }
      }
    }
    &-discount {
      &-text {
        color: var(--white);
        font-family: var(--font-bold);
        font-size: rem(16px);
        font-style: normal;
        font-weight: 500;
        line-height: rem(23px);
      }
      &-plans {
        color: var(--light-blue-gray);
        font-size: rem(12px);
        font-style: normal;
        font-weight: 450;
        line-height: rem(14px);
      }
    }
  }
  &__details {
    margin-bottom: 35px;
    font-weight: 450;
    font-size: rem(14px);
    line-height: rem(20px);
    &-two {
      color: var(--purple-pale);
      font-size: rem(16px);
      line-height: rem(23px);
      padding-bottom: 35px;
      margin-bottom: 15px;
    }
  }
  &__included-feature {
    background: var(--purple-gradient);
    position: absolute;
    width: 100%;
    float: left;
    bottom: 0;
    left: 0;
    border-radius: 0 0 10px 10px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 450;
    font-size: rem(12px);
    line-height: rem(14px);
  }
}
</style>
